function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEWolontariat2 = function SvgEWolontariat2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 155.5 155.5"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h155.5v155.5H0z",
    "data-name": "Warstwa 2",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Warstwa 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97.85 151.33H44.89c-24.27 0-44.01-19.74-44.01-44.01v-3.66h24.28v3.66c0 10.88 8.85 19.73 19.73 19.73h52.96z",
    style: {
      fill: "#5ea570"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.81 94.74c.51-13.84-4.09-26.54-12.97-35.75C76.17 50 64.33 45.24 50.61 45.24 21.8 45.24.89 66.91.89 96.77v9.93h96.96zM26.98 84.68c3.63-11.01 12.05-17.23 23.63-17.23s20.48 7.19 22.45 17.23z",
    style: {
      fill: "#091f2c"
    }
  })));
};
export default SvgEWolontariat2;